import { DatoCmsSportNav } from 'lib/datoCms/types';
import { ItemWithTranslation } from 'types/swagger';
import React from 'react';
import { SportNav } from '../sportNav';
import classNames from 'classnames';
import { selectIsOpenCarrello } from 'features/carrello/carrelloSelectors';
import { selectMenuManifestazioni } from 'features/sport/selectors';
import { seoItemHierarchy } from 'components/staticMap';
import styles from './SportInternalLayout.module.scss';
import { useSelector } from 'react-redux';
import useWindowSize from 'hooks/useWindowSize';

export type SportInternalLayoutProps = ItemWithTranslation<{ disciplina?: string }> & {
  sportNav?: DatoCmsSportNav;
  children?: React.ReactNode;
  staticMenu?: seoItemHierarchy;
  noPaddingTop?: boolean;
  manifestazione?: string;
};

export const SportInternalLayout: React.FC<SportInternalLayoutProps> = ({
  sportNav,
  children,
  disciplina,
  staticMenu,
  noPaddingTop,
  manifestazione,
}) => {
  const isOpen = useSelector(selectIsOpenCarrello);
  const { isMobile } = useWindowSize();
  const { gruppi, preferiti } = useSelector(selectMenuManifestazioni);

  const renderNav = () => {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    if (!sportNav) return <React.Fragment key={'sport-nav'} />;

    const { totocalcio, manifestazioniInEvidenza } = sportNav ?? {};
    return (
      <SportNav
        className={isMobile ? '' : styles.mobileOff}
        gruppi={gruppi ?? []}
        staticMenu={staticMenu}
        disciplina={disciplina}
        totocalcio={totocalcio}
        manifestazione={manifestazione}
        manifestazioniPreferiti={preferiti ?? []}
        manifestazioniInEvidenza={manifestazioniInEvidenza}
      />
    );
  };

  return (
    <div className={classNames(styles.container, { [styles.open]: isOpen, [styles.noPaddingTop]: noPaddingTop })}>
      {renderNav()}
      <div className={styles.childrenContainer}>{children}</div>
    </div>
  );
};
